import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { PublicPage } from '../PublicPage';

export class TermPage extends PublicPage {
    public static render(params: RouteParams): void {
        super.render(params);

        if ($('body').hasClass('page-vocabulary-soluciones')) {
            TermPage._generateSolutionsAnchors();
            TermPage._calculateBannerContentTranslation();
        }
    }

    private static _generateSolutionsAnchors(): void {
        const menuTabs = $('#nav-tab .nav-link');

        menuTabs.on('click', function () {
            $('.anchor-link').removeClass('active');
            $('.all-tab').addClass('active');
            $('.section').addClass('show');
            if ($(window).width() <= 765) {
                $("html, body").animate({ scrollTop: ($('#nav-tabContent').offset().top) - 230 }, 200);
            }
        });

        const tabs = $('.tab-content').find('.tab-pane');

        tabs.each(function () {
            const sections = $(this).find('.section');
            const anchors_container = $(this).find('.menu_anchors');
            const all_tabs = anchors_container.find('.all-tab');

            sections.each(function () {
                const title_sections = $(this).find('h3').text();
                const id = $(this).attr('id');
                const button = document.createElement("button");
                button.classList.add("anchor-link");
                button.setAttribute("data-id", '#' + id);
                button.innerHTML = title_sections + '';
                anchors_container.append(button);
            });

            all_tabs.on('click', function () {
                $('.anchor-link').removeClass('active');
                $(this).addClass('active');
                sections.addClass('show');
            });

            $(this).on('click', '.read-info', function () {
                const description_block = $(this).parent().find('.description');

                description_block.toggleClass('cropped-text');

                if (description_block.hasClass('cropped-text')) {
                    $(this).text(Drupal.t("Leer más"));
                } else {
                    $(this).text(Drupal.t("Leer menos"));
                }
            });
        });

        $('.anchor-link:not(.all-tab)').on('click', function () {
            $('.anchor-link').removeClass('active');
            $(this).addClass('active');
            $('.section').removeClass("show");

            const id = $(this).attr('data-id');
            $('' + id).addClass("show");
        });
    }

    private static _calculateBannerContentTranslation(): void {
        const banner = $('.banner');
        if (banner.length == 0) return;

        const bannerContainer = banner.find('.banner__container');
        bannerContainer.height(banner.height());
        const introBlue = $('.intro_blue');

        if (introBlue.length == 0) return;

        TermPage._translate(bannerContainer, introBlue);

        $(window).on('scroll', function () {
            TermPage._translate(bannerContainer, introBlue);

        });

        $(window).on('resize', function () {
            bannerContainer.height(banner.height());
            TermPage._translate(bannerContainer, introBlue);
        });
    }

    private static _translate(bannerContainer: JQuery, introBlue: JQuery): void {

        const heightVindow = $(window.top).height();
        const percentage = introBlue.innerHeight() * 100 / heightVindow;

        let top = $(window).scrollTop();
        top = top * percentage / 100;
        bannerContainer.css('transform', 'translate(0,-' + top + 'px');
    }
}
